import { Pipe, PipeTransform } from '@angular/core';
import { Entry } from 'contentful';

@Pipe({
  name: 'findResource'
})
export class FindResourcePipe implements PipeTransform {
  transform(values: Array<Entry<any>>, key: string): any {
    if (!values || values.length <= 0) {
      return '';
    }

    const resources = values.filter(value => {
      return value.fields.key === key;
    });

    if (resources.length > 0) {
      return resources[0].fields.value;
    }
    return '';
  }
}
